import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import useRoundGate from '../../hooks/useRoundGate';
import useBlockInspect from '../../hooks/useBlockInspect';
import { clearGettime } from '../../utils/santaCookies';
import { extraMileHome } from '../../data/greenDiwali';
import { isFromMobileAppClient } from '../../components/ExtraMileHeader/ExtraMileHeader';
import { IMG, pageBg } from '../../data/santaStages';
import GameBanner from '../../components/GameBanner/GameBanner';
import './WelcomePage.css';

function gameFinished(status) {
  return Boolean(status?.alreadyPlayed || status?.nextStage === 'thank-you');
}

export default function WelcomePage() {
  const user = useSelector((s) => s.auth.user);
  const { ready, status, error } = useRoundGate(0);
  const finished = gameFinished(status);

  useEffect(() => clearGettime(), []);
  useBlockInspect();

  useEffect(() => {
    if (!ready || !finished) return undefined;
    let closed = false;
    Swal.fire({
      title: '',
      text: 'You have played this game already',
      icon: 'error',
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      customClass: { confirmButton: 'hf-swal-close', popup: 'hf-swal-popup' },
      buttonsStyling: false,
    }).then(() => {
      if (closed) return;
      if (isFromMobileAppClient() && typeof window.GameStatus?.postMessage === 'function') {
        window.GameStatus.postMessage('navigate_back');
        return;
      }
      window.location.href = user?.backButtonRedirect || extraMileHome();
    });
    return () => {
      closed = true;
      Swal.close();
    };
  }, [ready, finished, user]);

  return (
    <div className="santa-intro" style={pageBg('loginbg.jpg', 'bg1mob.jpg')}>
      <div className="container-fluid" style={{ marginTop: 0 }}>
        <GameBanner />
        <div className="row">
          <div className="col-sm-4 col-md-4 col-lg-4 col-xs-12 auto">
            {error ? <p className="santa-intro-error">{error}</p> : null}
            <img src={`${IMG}/Who-kidnapped-Santa.gif`} className="img-fluid" style={{ width: '100%' }} alt="" />
          </div>
        </div>
      </div>
      <div className="col-md-12 text-center" style={{ marginTop: 0 }}>
        {ready && !finished ? (
          <Link to="/rules">
            <div className="btn btn-info begin">PLAY NOW</div>
          </Link>
        ) : null}
      </div>
    </div>
  );
}
